var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Alert, Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { NumberField, ReferenceField, Show, TextField, useRecordContext } from "react-admin";
import { ListDocument } from "./ListDocument";
import { JsonField } from "react-admin-json-view";
import { useApolloClient } from "@apollo/client";
import { FETCH_DOCUMENT } from "../../queries/FetchDocument";
import { CircularProgress } from "@mui/material";
import { downloadUrl } from "@sequentech/ui-core";
export var DocumentProperties = function () {
    var record = useRecordContext();
    var client = useApolloClient();
    var _a = useState(false), downloading = _a[0], setDownloading = _a[1];
    var _b = useState(), downloadError = _b[0], setDownloadError = _b[1];
    useEffect(function () { return setDownloadError(undefined); }, [record === null || record === void 0 ? void 0 : record.id]);
    var downloadDocument = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!record || downloading)
                        return [2 /*return*/];
                    setDownloading(true);
                    setDownloadError(undefined);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, client.query({
                            query: FETCH_DOCUMENT,
                            variables: { electionEventId: record.election_event_id, documentId: record.id },
                            fetchPolicy: "network-only",
                        })];
                case 2:
                    data = (_b.sent()).data;
                    if (!((_a = data === null || data === void 0 ? void 0 : data.fetchDocument) === null || _a === void 0 ? void 0 : _a.url))
                        throw new Error("Document download unavailable");
                    return [4 /*yield*/, downloadUrl(data.fetchDocument.url, record.name || "report.pdf")];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _b.sent();
                    setDownloadError(error_1 instanceof Error ? error_1.message : String(error_1));
                    return [3 /*break*/, 6];
                case 5:
                    setDownloading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    if (!record)
        return null;
    return (_jsxs(Box, { sx: { padding: "16px", display: "flex", flexDirection: "column", gap: "10px" }, children: [_jsx(TextField, { source: "name", fontSize: "24px", fontWeight: "bold" }), _jsx(Typography, { variant: "body1", children: "Media Type" }), _jsx(TextField, { source: "media_type" }), _jsx(Button, { onClick: downloadDocument, disabled: downloading, children: "Download Document" }), downloading ? _jsx(CircularProgress, {}) : null, downloadError ? _jsx(Alert, { severity: "error", children: downloadError }) : null, _jsx(Typography, { variant: "body1", children: "Size (bytes)" }), _jsx(NumberField, { source: "size" }), _jsx(Typography, { variant: "body1", children: "Election Event" }), _jsx(ReferenceField, { source: "election_event_id", reference: "sequent_backend_election_event", children: _jsx(TextField, { source: "name" }) }), _jsx(Typography, { variant: "body1", children: "Labels" }), _jsx(JsonField, { source: "labels", jsonString: false, reactJsonOptions: {
                    name: null,
                    collapsed: true,
                    enableClipboard: true,
                    displayDataTypes: false,
                } }), _jsx(Typography, { variant: "body1", children: "Annotations" }), _jsx(JsonField, { source: "annotations", jsonString: false, reactJsonOptions: {
                    name: null,
                    collapsed: true,
                    enableClipboard: true,
                    displayDataTypes: false,
                } })] }));
};
export var ShowDocument = function () {
    return (_jsx(ListDocument, { aside: _jsx(Show, { sx: { flexGrow: 2, width: "50%", flexShrink: 0 }, children: _jsx(DocumentProperties, {}) }) }));
};
